import React from "react";
import "./PasswordBus.css";

const PasswordBus = ({ strength, isVisible }) => {
  // Calculate bus mood based on password strength
  const getBusMood = () => {
    if (!strength) return "sleeping";
    if (strength < 40) return "worried";
    if (strength < 70) return "thinking";
    return "happy";
  };

  return (
    <div className="password-bus-container">
      <div className={`bus ${getBusMood()}`}>
        <div className="bus-body">
          {/* Windows/Eyes */}
          <div className="bus-windows">
            <div className={`window ${isVisible ? "open" : ""}`}>
              <div className="eye" />
            </div>
            <div className={`window ${isVisible ? "open" : ""}`}>
              <div className="eye" />
            </div>
          </div>

          {/* Wheels */}
          <div className="wheels">
            <div className="wheel" />
            <div className="wheel" />
          </div>

          {/* Bus expressions */}
          <div className={`bus-expression ${getBusMood()}`}>
            <div className="mouth" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PasswordBus;
